module.exports = __webpack_public_path__ + "static/assets/d03e487db0cb9644bb861d82462490d1.svg";